export const isDev =
  !process.env.NODE_ENV || process.env.NODE_ENV === "development";

export const ApplicationApiEndpoint = isDev
  ? "http://localhost:5001/api/v1.0/"
  : "https://www.strongfoundation.dev/api/v1.0/";
export const ApplicationClientEndpoint = isDev
  ? "http://localhost:3000/"
  : "https://www.strongfoundation.dev/";
export const SpotifyRedirectUri = isDev
  ? "http://localhost:50001/workoutbuilder"
  : "https://www.strongfoundation.dev/workoutbuilder";
export const SpotifyClientId = "99cd21c4e460477596ecbad9976f2680";
